import { render, staticRenderFns } from "./TransacoesPagarme.vue?vue&type=template&id=5cdf84c2&"
import script from "./TransacoesPagarme.vue?vue&type=script&lang=js&"
export * from "./TransacoesPagarme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports